import { useSelector } from 'react-redux';
import { useGetBuildDistroBucketSettingFieldsQuery } from '@/middlewares/defaultApi';
import type { RootState } from '@/reducers/reducers';
import { selectIsDemoInstanceOrDemoModeEnabled } from '@/selectors/selectors';
import { SettingFieldType, type SettingField } from '@/types';

// Demo apps aren't stored, so the endpoint can't serve them; a hand copy of the fields that need no integrations
const DEMO_SETTING_FIELDS: SettingField[] = [
    {
        key: 'name',
        type: SettingFieldType.Input,
        label: 'Bucket name',
        required: true,
        placeholder: 'Enter a bucket name',
    },
    { key: 'orgWideAccessEnabled', type: SettingFieldType.Switch, label: 'Enable org-wide access' },
    { key: 'publicBucketLinkEnabled', type: SettingFieldType.Switch, label: 'Enable public bucket link' },
];

// A new bucket has no bucketId; its fields carry no saved values
export const useBuildDistroBucketSettingFields = (
    orgId: string,
    appId: string,
    bucketId: string | undefined,
    skip: boolean,
): { settingFields: SettingField[] | undefined; isLoadingSettingFields: boolean } => {
    const isDemoMode = useSelector((state: RootState) => selectIsDemoInstanceOrDemoModeEnabled(state, orgId));
    const { data, isFetching } = useGetBuildDistroBucketSettingFieldsQuery(
        { orgId, appId, bucketId },
        { refetchOnMountOrArgChange: true, skip: skip || isDemoMode },
    );

    return {
        settingFields: isDemoMode ? DEMO_SETTING_FIELDS : data?.data,
        isLoadingSettingFields: isFetching,
    };
};
